import type { EmblaOptionsType } from 'embla-carousel';
import { cx } from '@/modules/common/helpers/classNames';

export const EMBLA_CAROUSEL_CONFIG = {
  heightTransitionDuration: '0.3s',
  viewportPadding: '16px',
  paginationSpace: '48px',
  noOffset: '0',
  groupedFlex: '0 0 100%',
  autoFlex: '0 0 auto',
};

export const getSlideClasses = (
  key: number,
  selectedIndex: number,
  total: number
): string => {
  const prevIndex = (selectedIndex - 1 + total) % total;
  const nextIndex = (selectedIndex + 1) % total;

  return cx(
    'embla__slide',
    key === selectedIndex ? 'active' : '',
    key === prevIndex ? 'prev' : '',
    key === nextIndex ? 'next' : '',
    key === total - 1 ? 'last' : ''
  );
};

export const getFixedSlideWidth = (slidesPerView: number) =>
  `${(100 / slidesPerView).toFixed(2)}%`;

export const getContainerMarginLeft = (
  grouped?: boolean,
  spaceBetween?: number
) =>
  !grouped && spaceBetween
    ? `-${spaceBetween}px`
    : EMBLA_CAROUSEL_CONFIG.noOffset;

export const getSlidePaddingLeft = (
  grouped?: boolean,
  spaceBetween?: number
) =>
  !grouped && spaceBetween
    ? `${spaceBetween}px`
    : EMBLA_CAROUSEL_CONFIG.noOffset;

export const getSlideFlex = (grouped?: boolean, slidesPerView?: number) => {
  if (grouped) return EMBLA_CAROUSEL_CONFIG.groupedFlex;
  return slidesPerView
    ? `0 0 ${getFixedSlideWidth(slidesPerView)}`
    : EMBLA_CAROUSEL_CONFIG.autoFlex;
};

export const getGroupJustifyContent = (align?: EmblaOptionsType['align']) => {
  switch (align) {
    case 'end':
      return 'flex-end';
    case 'center':
      return 'center';
    default:
      return 'flex-start';
  }
};
